import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const CreateShopSection = styled.div`
  border-radius: 21px;
  background: ${({ theme }) => theme.palette.primary.background};
  padding: 40px 35px;
  flex: 0 0 calc(50% - 20px);
  min-width: 0;
  box-sizing: border-box;
  align-self: flex-start;
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 1 1 100%;
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 25px 15px;
  }
`;

export const CreateShopTitle = styled(Typography.Header)`
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 700;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 20px;
  }
`;

export const CreateShopDescription = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.labels};
  margin-bottom: 30px;
  line-height: 1.5;
`;

export const CreateShopButton = styled.button`
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.brand.main};
  color: ${({ theme }) => theme.palette.primary.background};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  padding: 15px 35px;
  width: 200px;
  border: 0;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.palette.brand.main};
    opacity: 0.9;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;
